<script>
export default {
  inserted: function (el) {
    let headers = el.getElementsByClassName("header-item");
    let sections = el.getElementsByClassName("items");
    let setOnclick = function (ctl, id) {
      ctl.onclick = function () {
        for (let i = 0; i < headers.length; i++) {
          headers[i].classList.remove("active");
          sections[i].classList.remove("active");
        }
        headers[id].classList.add("active");
        sections[id].classList.add("active");
        return false;
      };
    };
    for (let i = 0; i < headers.length; i++) {
      setOnclick(headers[i], i);
    }

    let setPopupImageClick = function (el) {
      el.getElementsByClassName("social-img")[0].onclick = function () {
        el.classList.add("show-popup");
      };
      el.getElementsByClassName("popup")[0].onclick = function () {
        el.classList.remove("show-popup");
      };
    };

    let popupImages = el.getElementsByClassName("popup-image");
    for (let i = 0; i < popupImages.length; i++) {
      setPopupImageClick(popupImages[i]);
    }
  },
};
</script>